import { array, number, object, string, } from 'yup';
const fitnessMember = {
    type: string().required('Type is required'),
    firstName: string().required('Please enter a first name'),
    lastName: string().required('Please enter a last name'),
};
export const fitnessMemberSchema = object(fitnessMember);
const fitness = {
    // duration of membership
    membershipLength: number().nullable(),
    // payment interval for membership
    membershipCategory: number().nullable(),
    membershipPayment: number().nullable(),
    members: array(fitnessMemberSchema).min(1, 'Please select at least 1 member'),
    membershipId: number().nullable(),
};
export const fitnessSchema = object(fitness);
